module.exports = __webpack_public_path__ + "img/pr-10.f562fed8.png";